<template>
  <div class="page-container">
    <div class="pay-trans-details">
      <div class="filter-section-container">
        <div class="filter-fixed">
          <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
          <i
            class="el-icon-arrow-down filter-fixed-arrow"
            :class="{'fiter-icon-arrow-route':!showFilterContent}"
            @click="onClickFixedArrow"
          />
        </div>
        <el-collapse-transition>
          <div v-show="showFilterContent">
            <div id="filter-content" class="filter-content">
              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
                <el-date-picker
                  v-model="search.create_time"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>
              <div class="filter-item" :class="{'border-red':isShowBorderRed}">
                <div class="filter-item-label">
                  {{ $t('merchantAccount.complete_time') }}
                </div>

                <el-date-picker
                  v-model="search.return_time"
                  class="filter-item-value"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="~"
                  :start-placeholder="$t('components.start_date')"
                  :end-placeholder="$t('components.end_date')"
                />
              </div>
              <!--            <div class="filter-item">-->
              <!--              <div class="filter-item-label">{{ $t('customerService.payment_method') }}</div>-->
              <!--              <el-select v-model="search.pay_product_type" class="filter-item-value" clearable @change="search.channel_code = null">-->
              <!--                <el-option-->
              <!--                  v-for="(item,index) in payinPaymentMethodMap"-->
              <!--                  :key="index"-->
              <!--                  :label="item.label"-->
              <!--                  :value="item.value"-->
              <!--                />-->
              <!--              </el-select>-->
              <!--            </div>-->

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('merchant.payment_channel') }}</div>
                <el-select v-model="search.channel_code" filterable class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in compFilterPaymentChannel"
                    :key="index"
                    :label="item.channel_code"
                    :value="item.channel_code"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.original_transaction_id') }}</div>
                <el-input v-model="search.original_transaction_id" type="text" class="filter-item-value" size="small" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.mch_refund_order_id') }}</div>
                <el-input v-model="search.mch_order_id" type="text" class="filter-item-value" size="small" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_transaction_id') }}</div>
                <el-input v-model="search.refund_transaction_id" size="small" type="text" class="filter-item-value" clearable />
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_type') }}</div>
                <el-select v-model="search.refund_category" filterable class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in refundStatusMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>

              <div class="filter-item">
                <div class="filter-item-label">{{ $t('customerService.refund_status') }}</div>
                <el-select v-model="search.status" filterable class="filter-item-value" size="small" clearable>
                  <el-option
                    v-for="(item,index) in refundTypeMap"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <div class="filter-item" />
            </div>
            <div class="filter-operate">
              <div class="filter-operate-left">
                <el-button class="mb-10 download-btn" :loading="downloading" type="info" size="small" icon="el-icon-download" @click="onClickDowmloadBtn">{{ $t('components.download') }}</el-button>
              </div>
              <div class="filter-operate-right">
                <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
                <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
              </div>

            </div>
          </div>

        </el-collapse-transition>
      </div>
      <div class="total-container">
        <div class="total-item">
          {{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ summaryData.total_refund_count }}</span>
        </div>
        <div class="total-item">
          {{ $t('customerService.full_refund_summary') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ summaryData.total_refund_amount | toDivideWithDot }}</span>
        </div>
        <div class="total-item">
          {{ $t('customerService.return_fee_summary') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ Math.abs(summaryData.total_fee_refunded) | toDivideWithDot }}</span>
        </div>
        <div class="total-item">
          {{ $t('customerService.total_refund_fee') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ Math.abs(summaryData.total_refund_fee) | toDivideWithDot }}</span>
        </div>
      </div>
      <div class="tableContainer">
        <!-- 列表 -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          stripe
          fit
          highlight-current-row
          style="width: 100%"
        >
          <!-- 原交易编号 -->
          <el-table-column min-width="110" :label="$t('customerService.original_transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.original_transaction_id }}</span>
            </template>
          </el-table-column>
          <!-- 商户退款订单号 -->
          <el-table-column min-width="110" :label="$t('customerService.mch_refund_order_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mch_order_id }}</span>
            </template>
          </el-table-column>
          <!-- 退款交易编号 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_transaction_id')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.refund_transaction_id }}</span>
            </template>
          </el-table-column>

          <!--        <el-table-column min-width="110" :label="$t('customerService.payment_method')" align="center">-->
          <!--          <template slot-scope="scope">-->
          <!--            <span>{{ getPayinPaymentMethodMap(scope.row.pay_product_type) }}</span>-->
          <!--          </template>-->
          <!--        </el-table-column>-->

          <!-- 支付方式 -->
          <el-table-column min-width="110" :label="$t('customerService.payment_method')" align="center">
            <template slot-scope="scope">
              <span>{{ getPayinPaymentMethodMap(scope.row.pay_product_type) }}</span>
            </template>
          </el-table-column>
          <!-- 支付渠道 -->
          <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.channel_code }}</span>
            </template>
          </el-table-column>
          <!-- 退款类型 -->
          <el-table-column :label="$t('customerService.refund_type')" align="center" min-width="150">
            <template slot-scope="scope">
              <div class="status-wrap">
                <el-tag :type="getRefundStatusMapType(scope.row.refund_category)" class="payin-status tag-custom"> {{ getRefundStatusMap(scope.row.refund_category) }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <!-- 原交易金额 -->
          <el-table-column min-width="110" :label="$t('customerService.original_transaction_amount')" align="center">
            <template slot-scope="scope">
              <span> {{ scope.row.original_transaction_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款订单金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_order_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.this_time_refund_amount | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退回手续费金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refunded_transaction_fee')" align="center">
            <template slot-scope="scope">
              {{ Math.abs(scope.row.refund_transaction_fee) | toDivideWithDot }}
            </template>
          </el-table-column>
          <!-- 退款交易金额 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_transaction_amount')" align="center">
            <template slot-scope="scope">
              <span>{{ Math.abs(scope.row.actual_receive_refund_amount) | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款手续费 -->
          <el-table-column min-width="110" :label="$t('customerService.refund_fee')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.refund_fee | toDivideWithDot }}</span>
            </template>
          </el-table-column>
          <!-- 退款状态 -->
          <el-table-column min-width="160" :label="$t('customerService.refund_status')" align="center">
            <template slot-scope="scope">
              <el-tag :type="getRefundTypeMapType(scope.row.status)" class="payin-status tag-custom"> {{ getRefundTypeMap(scope.row.status) }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_create_time }}</span>
            </template>
          </el-table-column>

          <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.transaction_return_time }}</span>
            </template>
          </el-table-column>

          <!--操作-->
          <el-table-column min-width="130" :label="$t('components.operation')" align="center">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">
                  <span> {{ $t('components.detail') }}</span> <br>
                </div>
                <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailTxt(scope.row)" />
              </el-tooltip>
            </template>
          </el-table-column>

        </el-table>

        <div class="pagination-container">
          <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
        </div>
      </div>
      <refund-details-modal ref="refundDetailsModal" :detail-id="detailId" :auth-merchant-no="$route.params.merchant_no" />

    </div>
  </div>
</template>

<script>

import { partnerPaymentRefundList, partnerPaymentRefundDownload } from '@/api/service-provider-tools/service-provider-tools'
import { fetchPageMethodChannelList } from '@/api/components/components'

import { payTransactionStatusMap, refundStatusMap, refundDetailTypeMap } from '@/utils/maps'
import { payinPaymentMethodMap } from '@/maps/transaction'
import { filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils'

export default {
  name: 'Pay_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    RefundDetailsModal: () => import('@/views/paycools/data/components/Modal/RefundDetailsModal')
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        merchant_order_id: '',
        transaction_status: null, // 交易状态
        create_time: [appointDate(-3), appointDate()],
        return_time: [],
        channel_code: '',
        transaction_id: ''
      },
      payinChannelList: [],
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0,
        cur_page: 1,
        next_page_url: false
      },
      summaryData: {
        total_refund_count: 0, // 笔数汇总
        total_refund_amount: 0, // 退款交易金额汇总
        total_fee_refunded: 0, // 退回手续费汇总
        total_refund_fee: 0// 退款手续费汇总
      },
      detailId: '',
      downloading: false,
      isShowBorderRed: false
    }
  },
  computed: {
    getRefundTypeMapType() {
      return function(value) {
        return refundDetailTypeMap(value).type
      }
    },
    getRefundTypeMap() {
      return function(value) {
        return refundDetailTypeMap(value).label
      }
    },
    getRefundStatusMapType() {
      return function(value) {
        return refundStatusMap(value).type
      }
    },
    getRefundStatusMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    },
    payTransactionStatusArr() {
      return payTransactionStatusMap()
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => {
        if (this.search.pay_product_type === '4,5') {
          return [4, 5].includes(item.payment_method)
        }
        return item.payment_method === this.search.pay_product_type
      })
      return arr
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        if ([4, 5].includes(value)) {
          return payinPaymentMethodMap('4,5').label
        }
        return payinPaymentMethodMap(value).label
      }
    },
    payinPaymentMethodMap() {
      let list = payinPaymentMethodMap()
      list = list.filter(item => {
        if (item.type === 'hide') {
          return false
        }
        return true
      })
      return list
    },
    refundTypeMap() {
      return refundDetailTypeMap()
    },
    refundStatusMap() {
      return refundStatusMap()
    },
    refundStatusLabelMap() {
      return function(value) {
        return refundStatusMap(value).label
      }
    }
  },
  created() {
    this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      fetchPageMethodChannelList({
        auth_merchant_no: this.$route.params.merchant_no
      }).then(res => {
        this.payinChannelList = res.data || []
      })
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      partnerPaymentRefundList(params).then(res => {
        const { total = 15, list = [], current = 1, hasNext = false, total_refund_amount, total_fee_refunded, total_refund_fee, total_refund_count } = res.data
        this.listQuery.total = total
        this.listQuery.page = params.page ? params.page : 1
        this.listQuery.cur_page = current
        this.listQuery.next_page_url = hasNext
        this.tableData = list
        this.summaryData = { total_refund_count, total_refund_amount, total_fee_refunded, total_refund_fee }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { create_time = [], return_time = [], ...otherSearch } = this.search
      let params = {
        transaction_create_time_start: create_time && create_time[0] + ' 00:00:00',
        transaction_create_time_end: create_time && create_time[1] + ' 23:59:59',
        ...otherSearch,
        ...otherParams,
        auth_merchant_no: this.$route.params.merchant_no
      }
      if (return_time && return_time.length !== 0) {
        params = {
          transaction_return_time_start: return_time && return_time[0] + ' 00:00:00',
          transaction_return_time_end: return_time && return_time[1] + ' 23:59:59',
          ...params
        }
      }
      if ((!create_time || create_time.length === 0) && (!return_time || return_time.length === 0)) {
        this.$message.warning('pls enter at least one query date!')
        return null
      }
      params = filterEmptyAttr(params)
      return params
    },

    showPayDetailModal(row) {
      this.$refs.refundDetailsModal.changModalStatus(true, row)
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickDetailTxt(row) {
      this.detailId = row.transaction_id
      this.showPayDetailModal(row)
    },
    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickDowmloadBtn() {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 90)) {
        this.$message.warning('The maximum date range  is limited to 90 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.return_time, 90)) {
        this.$message.warning('The maximum date range  is limited to 90 days, please select again')
        return
      }

      const params = this.getParams()
      if (!params) {
        return
      }
      this.downloading = true
      partnerPaymentRefundDownload(params).then(res => {
        const { is_async } = res.data || {}
        if (is_async) {
          this.$message.success('Downloading')
          this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
        }
      }).finally(() => {
        setTimeout(() => {
          this.downloading = false
        }, 3000)
      })
    },

    onClickPaginator() {
      const { page, limit } = this.listQuery
      const params = {
        page,
        limit
      }
      this.handleFilter(params)
    },
    confirmPaginator(page) {
      const params = {
        page
      }
      this.handleFilter(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
    cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}

.wayBill_item {
  padding: 10px 20px !important;
}
</style>
